import React from 'react'
import UnlockAccountPage from './UnlockAccountPage'

export * from './UnlockAccountPage'
export default React.memo(UnlockAccountPage)
